export type LeadDetailsDesignVersion = 'v1' | 'v2'

export function isLegacy(version: LeadDetailsDesignVersion) {
  return version === 'v1'
}
